import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import image from "../Assests/Images/payment_fail.svg";  
import logo from "../Assests/Images/tfs_logo.png"
// Instead of importing an image, directly use the URL
const PaymentFailure = ({payment_link=''}) => {
  return (
    <Container className="min-vh-100">
      <Row className="justify-content-center align-items-center min-vh-100 mx-0">

        <Col md={8}>
          <div className="">
            <div className="" style={{ display: 'flex', justifyContent: 'center' }}>
              <img src={logo} alt="logo" className="" style={{ height: '60px', width: '120px', marginBottom: '20px' }} />
            </div>
            <div className="text-center">
              <img 
                src={image}
                alt="Payment Failed" 
                style={{ width: '150px', marginBottom: '20px' }} 
              />
              <h1 className="text-danger">Payment Failed!</h1>
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                <p className="text-muted mb-4" style={{ fontSize: '1.1rem', maxWidth: '400px', textAlign: 'center' }}>Unfortunately, your payment was not successful. Please try again or contact support.</p>
              </div>
              <div className="" style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' , gap: '20px'}}>
               
                <Button variant="outline-secondary" size="lg" className="px-4 py-2" target='_blank' href="https://tfsfinserv.com/contact.html">
                  Contact Support
                </Button>
                <div className="d-grid gap-2" style={{ maxWidth: '240px' }}>
                  <Button 
                    variant="primary" 
                    href="/customer-login"
                    size="lg"
                    className="px-4 py-2"
                  >
                    Go to Home
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default PaymentFailure
